import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { parseEnlacePayload, getRedirectUrl } from '../../service/enlaces';

class EnlacesRedirectComponent extends Component {
    componentDidMount() {
        const { payload } = this.props.match.params;
        const parsed = parseEnlacePayload(payload);
        
        if (parsed) {
            const redirectUrl = getRedirectUrl(parsed.type, parsed.id);
            this.props.history.replace(redirectUrl);
        }
    }

    render() {
        const { payload } = this.props.match.params;
        const parsed = parseEnlacePayload(payload);
        
        if (parsed) {
            const redirectUrl = getRedirectUrl(parsed.type, parsed.id);
            return <Redirect to={redirectUrl} />;
        }
        
        return (
            <div className="content-wrapper p-5">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <h1>Enlace no válido</h1>
                        <p>El enlace que intentaste acceder no es válido o ha expirado.</p>
                        <a href="/procedimientos" className="btn btn-primary">Volver a procedimientos</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default EnlacesRedirectComponent;
